import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "mt-8 md:mt-4" }
const _hoisted_3 = { class: "text-3xl font-medium" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-8 md:mt-2"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-8 md:mt-2"
}

import { ref, watch } from "vue";
import api from "@/api/api";
import { useRoute, useRouter } from "vue-router";
import { useFilters } from "@/composables/filters";

import RoleGuard from "@/components/RoleGuard.vue";
import RouterButton from "@/components/RouterButton.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import ClubSurveyTable from "@/components/tables/ClubSurveyTable.vue";
import TabGroup from "@/components/TabGroup.vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SatifcationSurveyClub',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();
const { resetFiltersNoRefresh } = useFilters(route);

const { user } = storeToRefs(useUserStore());

const satisfactionTotal = ref(0);

const url = `${process.env.VUE_APP_WEBSITE_URL}/howto`;

const tabs = [
  { name: "By Country", id: "country" },
  { name: "By Organisation", id: "organisation" },
];

const selectedTab = route.query.tab ? ref(route.query.tab) : ref("country");

async function getSatisfaction() {
  const res = await api.surveys.getSurveySatifactionClubOverall();
  satisfactionTotal.value = res?.data?.overallScore;
}

watch(selectedTab, async (newTab, oldTab) => {
  if (newTab !== oldTab) {
    resetFiltersNoRefresh();
    router.replace({
      query: {
        tab: newTab,
      },
    });
    route.query.tab = newTab;
  }
});

if (!user.value.has_smartsurvey_access) {
  window.location.href = "/dashboard";
}

;(
  ([__temp,__restore] = _withAsyncContext(() => getSatisfaction())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RouterButton, {
        type: "primary",
        to: { path: `/dashboard` }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("back-to")) + " " + _toDisplayString(_ctx.$t("dashboard")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("average-brick-club-session-feedback")) + " " + _toDisplayString(_ctx.$t("out-of-10")) + ": " + _toDisplayString(satisfactionTotal.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ExternalLink, {
          type: "text",
          label: _ctx.$t('what-does-this-mean'),
          href: url,
          capitalize: false
        }, null, 8, ["label"])
      ])
    ]),
    _createVNode(RoleGuard, { roles: ['facilitator-organisation'] }, {
      default: _withCtx(() => [
        _createVNode(ClubSurveyTable, {
          type: "",
          title: _ctx.$t('brick-club')
        }, null, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(RoleGuard, { roles: ['admin'] }, {
      default: _withCtx(() => [
        _createVNode(TabGroup, {
          tabs: tabs,
          selectedTab: _unref(selectedTab),
          onSelect: _cache[0] || (_cache[0] = (tab) => selectedTab.value = tab)
        }, null, 8, ["selectedTab"]),
        (_unref(selectedTab) === 'country')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(ClubSurveyTable, {
                type: "country",
                title: _ctx.$t('country')
              }, null, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        (_unref(selectedTab) === 'organisation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(ClubSurveyTable, {
                type: "organisation",
                title: _ctx.$t('organisation')
              }, null, 8, ["title"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})